import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";

function AutosaveIndicator({ status, lastSavedAt }) {
  if (status === "pending") {
    return (
      <Chip
        color="warning"
        variant="outlined"
        icon={<CircularProgress size={14} />}
        label="Autosaving"
      />
    );
  }

  if (lastSavedAt) {
    return (
      <Chip
        color="success"
        variant="outlined"
        label={`Saved`}
      />
    );
  }

  return null;
}

export default AutosaveIndicator;
